export default __webpack_public_path__ + "static/xcad-app-v2-845f316495b7be505d7a9025b49a473b.mp4";